import { Check } from "lucide-react";

const ProgressBar = ({ currentStep, totalSteps, stepIcons, stepTitles }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => {
          const StepIcon = stepIcons[step - 1];
          const isCompleted = step < currentStep;
          const isCurrent = step === currentStep;
          
          return (
            <div key={step} className="flex flex-col items-center">
              <div 
                className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                  isCompleted
                    ? 'bg-[#D4AF37] text-black' 
                    : isCurrent 
                      ? 'bg-[#D4AF37] text-black ring-4 ring-[#D4AF37]/30' 
                      : 'bg-[#1a1a1a] text-[#666] border border-white/10'
                }`}
              >
                {isCompleted ? (
                  <Check className="w-5 h-5" />
                ) : (
                  <StepIcon className="w-5 h-5" />
                )}
              </div>
              <span className={`text-xs mt-2 hidden sm:block ${
                step <= currentStep ? 'text-[#D4AF37]' : 'text-[#666]'
              }`}>
                {stepTitles[step - 1]}
              </span>
            </div>
          );
        })}
      </div>
      <div className="h-2 bg-[#1a1a1a] rounded-full overflow-hidden">
        <div 
          className="h-full bg-gradient-to-r from-[#D4AF37] to-[#E5C158] transition-all duration-500"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
      <p className="text-center text-sm text-[#A3A3A3] mt-2">
        Step {currentStep} of {totalSteps}
      </p>
    </div>
  );
};

export default ProgressBar;
